import React, { useEffect, useState } from "react";
import {
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  CircularProgress,
} from "@mui/material";
import "./Footer.css";
import { useWithSessionData } from "../../hooks/use-with-session-data";
import { handleButtonClickEventBuilder, sendEvent } from "../../utils/event-helpers";

const Footer = ({ completedPostSurvey }: { completedPostSurvey: boolean }) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [openTimerPopup, setOpenTimerPopup] = useState(false);
  const { userId, sessionId } = useWithSessionData();
  const [isSendingEvent, setIsSendingEvent] = useState(false);
  const [timeElapsed, setTimeElapsed] = useState(0);
  const openPopupTimeInSeconds = 3 * 60; // 3 minutes

    useEffect(() => {
      let interval;
        if (timeElapsed < openPopupTimeInSeconds) {
          interval = setInterval(() => {
            setTimeElapsed((prev) => prev + 1);
          }, 1000);
        }else{
          setOpenTimerPopup(true);
        }
  
      return () => clearInterval(interval);
    }, [timeElapsed, openPopupTimeInSeconds]);
  

  const handlePrevious = () => {
    setOpenPopup(true); // Always show the popup on click
    const eventData = handleButtonClickEventBuilder(userId, sessionId, "Previous Button", {});
    sendEvent(eventData);
  };

  const handleClosePopup = () => {
    const eventData = handleButtonClickEventBuilder(userId, sessionId, "Close Qualtrics Reminder Popup", {});
    sendEvent(eventData);
    setOpenPopup(false);
  };

  const handleFinishSurvey = async (logTitle: string) => {
    try {
      setIsSendingEvent(true);
    const eventData = handleButtonClickEventBuilder(userId, sessionId, logTitle, {});
    await sendEvent(eventData);
    }catch(error){
      console.error("Error sending finish survey event:", error.message);
    }finally{
      setIsSendingEvent(false);
      window.location.href =
        "https://fullerton.qualtrics.com/jfe/form/SV_a5hdjwphH1WkzAy/?userid=" +
        userId;
    }
  };


  return (
    <Box className="footer-container">
      <Button className="footer-button" onClick={handlePrevious}>
        Previous
      </Button>
      <Button className="footer-button" onClick={() => handleFinishSurvey("Finish Survey")} disabled={isSendingEvent || completedPostSurvey}>
        FINISH SURVEY {isSendingEvent && <CircularProgress size={20} />}
      </Button>

      {/* Popup Dialog */}
      <Dialog
        open={openPopup}
        onClose={handleClosePopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Reminder</DialogTitle>
        <DialogContent>
          <Typography>
            You've visited the MentorPal page. Please complete the Qualtrics
            survey.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopup} color="primary">
            Close
          </Button>
          <Button onClick={() => handleFinishSurvey("Go to Qualtrics")} color="primary" disabled={isSendingEvent}>
            Go to Qualtrics {isSendingEvent && <CircularProgress size={20} />}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openTimerPopup}
        onClose={() => setOpenTimerPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Qualtrics Reminder</DialogTitle>
        <DialogContent>
          <Typography>
          We hope you've enjoyed this page.  Please now complete the Qualtrics survey.
          </Typography>
        </DialogContent>
        <DialogActions style={{
          display: 'flex',
          justifyContent: 'space-around',
          width: '100%',
        }}>
          <Button onClick={() => {
            setOpenTimerPopup(false);
            setTimeElapsed(0);
          }} color="primary">
            Snooze for 3 minutes
          </Button>
          <Button onClick={() => handleFinishSurvey("Go to Qualtrics")} color="primary" disabled={isSendingEvent}>
            Go to Qualtrics {isSendingEvent && <CircularProgress size={20} />}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Footer;
